import { api } from '@shared/config/axiosConfig';
import { insuranceCarrierFromDto, availableInsuranceCarrierFromDto, insuranceCarrierFromSoftsegurosFromDto } from '../mappers/insuranceCarriersMapper';
import { buildEndpoint } from '@shared/utils/buildEndpoint';

const BASE_ENDPOINT = 'insurance-carriers';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
}

export const getInsuranceCarriers = async (filters = {}) => {
  const params = {
    admin: filters.admin, // Opcional. Si es true retorna las aseguradoras con información adicional para administración
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return response.data.map(insuranceCarrierFromDto);
};

export const getAvailableInsuranceCarriers = async () => {
  const endpoint = buildServiceEndpoint({ action: 'available-to-add' });
  const response = await api.get(endpoint);
  return response.data.map(availableInsuranceCarrierFromDto);
};

export const getInsuranceCarriersFromSoftseguros = async () => {
  const endpoint = buildServiceEndpoint({ action: 'from-softseguros' });
  const response = await api.get(endpoint);
  return response.data.map(insuranceCarrierFromSoftsegurosFromDto);
}

export const createInsuranceCarrier = async ({ availableInsuranceCarrierId, softsegurosInsuranceCarrierId }) => {
  const data = {
    available_insurance_carrier_id: availableInsuranceCarrierId,
    softseguros_insurance_carrier_id: softsegurosInsuranceCarrierId,
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, data);
  return insuranceCarrierFromDto(response.data);
};

export const uploadInsuranceCarrierCertificate = async (id, { file, password }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('password', password);

  const endpoint = buildServiceEndpoint({ id, action: 'certificate' });
  const response = await api.patch(endpoint, formData);
  return response.data;
};